/* eslint-disable prefer-destructuring */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable quotes */
/* eslint-disable react/jsx-curly-brace-presence */
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
  Box,
  Button
} from '@material-ui/core';

const Email_Self_Instructions = (props) => {
  const assessmentType = props.assessmentType;
  const participantName = props.participantname;
  const assessorName = props.assessorname;
  const relation = props.relation;
  return (
    <>
      <Grid container spacing={6} wrap="wrap">
        <Grid item lg={6} md={6} sm={6} sx={12} xs={12}>
          <Typography
            color="textPrimary"
            gutterBottom
            variant="body1"
            style={styles.nameStyle}
          >
            {`Hi ${participantName},`}
          </Typography>
        </Grid>
        <Grid item lg={6} md={6} sm={6} sx={12} xs={12}>
          <Box
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginBottom: 10
            }}
          >
            <img
              alt="Logo"
              width={70}
              height={55}
              src="/static/logo.png"
              {...props}
            />
          </Box>
        </Grid>
      </Grid>
      <Card style={styles.cardStyle}>
        <CardHeader
          color="primary"
          title="Instructions"
          style={styles.cardHeaderStyle}
        />
        <Divider />
        <CardContent style={styles.cardContentStyle}>
          <Grid container spacing={6} wrap="wrap">
            <Grid item md={12} sm={12} sx={12} xs={12}>
            <Typography color="textPrimary" variant="body2">
                Hi Respondent,{' '}
                {/* <p style={{ marginTop: 20 }}>
                  This questionnaire is about your perception of the assesse
                </p> */}
              </Typography>
              <ul style={styles.listWrapInsStyle}>
                <li style={styles.listInsStyle}>
                  <Typography color="textPrimary" variant="body2">
                    {`As part of our focus on strengthening professional communication, we would like you to reflect on and evaluate your email writing skills. Your self-assessment will help identify both your current capabilities and areas where you’d like to improve. Feel free to include specific examples or reflections on what you think went well and what you would like to improve. Your input is valuable in supporting your growth in written communication.
`}
                  </Typography>
                </li>
                <li style={styles.listInsStyle}>
                  <Typography color="textPrimary" variant="body2">
                    {`This questionnaire is to evaluate your email writing skills`}
                  </Typography>
                </li>
                <li style={styles.listInsStyle}>
                  <Typography color="textPrimary" variant="body2">
                    {`You must answer all the questions below including the comment section`}
                  </Typography>
                </li>
                <li style={styles.listInsStyle}>
                  <Typography color="textPrimary" variant="body2">
                    {`Give a fair and honest evaluation as it is soley used for your development purposes`}
                  </Typography>
                </li>
                {/* <li style={styles.listInsStyle}>
                  <Typography color="textPrimary" variant="body2">
                    {`As far as possible try to base your answers on critical instances
              of this person's communication. The marking scale is 1-4 where "1" is
              the lowest and "4" is the highest score.`}
                  </Typography>
                </li> */}
              </ul>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2
          }}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={props.handleStartClick}
          >
            Start
          </Button>
        </Box>
      </Card>
    </>
  );
};

const styles = {
  nameStyle: {
    margin: 10
  },
  cardStyle: {
    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.35)',
    borderRadius: 10
  },
  cardContentStyle: {
    marginLeft: 10
  },
  listWrapInsStyle: {
    marginLeft: 20
  },
  listInsStyle: {
    paddingTop: 20
  },
  cardHeaderStyle: {
    color: '#f77445',
    backgroundColor: '#f4f4f4'
  }
};

export default Email_Self_Instructions;
